/* Mini-koszyk (popup) — otwierany z [data-cart-open] (header CART, toast).
   Zawartość odświeżana Section Rendering API; zmiana ilości i usuwanie
   pozycji przez /cart/change.js z parametrem sections (świeży HTML w tej
   samej odpowiedzi — atomowo). Bez JS linki nawigują na /cart.

   KONTRAKT: cały markup linii (sections/cart-popup-lines.liquid) jest
   renderowany OD NOWA przy każdej zmianie, więc tu NIE MA ani jednego
   addEventListener na węźle z sekcji — wszystko idzie delegacją z
   document, a stan czytamy z data-atrybutów świeżego DOM-u. Teksty
   (i18n) też przychodzą z Liquida w data-* — JS nie zna ani jednego
   stringa UI.

   Celowo NIE dotyka quick-view.js: koszyk otwiera się z headera/toastu,
   więc nigdy równocześnie z popupem produktu (toast pojawia się dopiero
   po jego zamknięciu). */
(function () {
  'use strict';

  var dlg = document.querySelector('[data-cart-pop]');
  if (!dlg || typeof dlg.showModal !== 'function' || !window.fetch) return;

  var panel = dlg.querySelector('.cart-pop__panel');
  var body = dlg.querySelector('[data-cart-pop-body]');
  var countEl = dlg.querySelector('[data-cart-pop-count]');
  var liveEl = dlg.querySelector('[data-cart-pop-live]');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var docEl = document.documentElement;
  var lastFocus = null;
  var busy = false;
  var queued = null; /* docelowa ilość z serii stuknięć w locie (patrz drain) */

  var DENY_MS = 420; /* długość pulsu odmowy (seg-deny-shake .38s + zapas) */
  var OUT_MS = 200; /* mikro-potwierdzenie usunięcia: kreska + odjazd linii */

  /* ten sam mechanizm co quick-view.js: kompensacja paska = grid nie skacze */
  function lock() {
    var gap = window.innerWidth - docEl.clientWidth;
    if (gap > 0) docEl.style.setProperty('--qv-sb', gap + 'px');
    docEl.classList.add('qv-open');
  }
  function unlock() {
    docEl.classList.remove('qv-open');
    docEl.style.removeProperty('--qv-sb');
  }

  function setCounts(n) {
    var t = '[' + n + ']';
    if (countEl) countEl.textContent = t;
    var h = document.querySelector('[data-cart-count]');
    if (h) h.textContent = t;
  }

  function swapBody(html) {
    if (body && typeof html === 'string') body.innerHTML = html;
  }

  /* Region żyje w shellu (przetrwa rerender sekcji). Zerowanie przed
     wpisem: dwa identyczne komunikaty pod rząd (np. dwa razy MAX STOCK)
     nie są ogłaszane, jeśli tekst się nie zmienił. */
  function announce(msg) {
    if (!liveEl || !msg) return;
    liveEl.textContent = '';
    window.setTimeout(function () { liveEl.textContent = msg; }, 60);
  }

  /* suma czytana ze ŚWIEŻEGO DOM-u (Liquid renderuje ją | money) */
  function withTotal(msg) {
    var t = body && body.querySelector('[data-cart-total-live]');
    var v = t && t.getAttribute('data-cart-total-live');
    return v ? msg + '. ' + v : msg;
  }

  /* klucz linii bywa dowolnym stringiem (np. "4:0e5…") — porównujemy
     atrybuty zamiast wstawiać go do selektora (zero problemów z escape) */
  function findLine(key) {
    var lines = body ? body.querySelectorAll('[data-cart-pop-line]') : [];
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].getAttribute('data-line-key') === key) return lines[i];
    }
    return null;
  }

  function padOf(line) { return line ? line.querySelector('[data-qty-pad]') : null; }
  function noteText(pad, name) { return pad ? pad.getAttribute(name) : ''; }
  function padLabel(pad) { return (pad && pad.getAttribute('aria-label')) || ''; }

  /* ODMOWA — ten sam gest co wyprzedany segment size-bara: pasek strzepuje,
     notka rozbłyska. Informacja jest w TEKŚCIE notki, animacja tylko ją
     wzmacnia (pod reduced-motion gaśnie, tekst zostaje). */
  function deny(line, msg) {
    if (!line) return;
    var pad = padOf(line);
    var note = line.querySelector('[data-qty-note]');
    if (note && msg) note.textContent = msg;
    if (pad) pad.classList.remove('qty-pad--deny');
    if (note) note.classList.remove('cart-pop__note--deny');
    if (pad) void pad.offsetWidth; /* reflow = restart keyframes przy 2. tapnięciu */
    if (pad) pad.classList.add('qty-pad--deny');
    if (note) note.classList.add('cart-pop__note--deny');
    window.setTimeout(function () {
      if (pad) pad.classList.remove('qty-pad--deny');
      if (note) note.classList.remove('cart-pop__note--deny');
    }, DENY_MS);
  }

  /* 422 z /cart/change.js niesie opis po stronie sklepu (np. "You can only
     add 3 of…") — zachowujemy go w err.data do ogłoszenia. Brak odpowiedzi
     (sieć) zostawia err bez .data: to INNY stan i inna notka. */
  function post(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r
        .json()
        .catch(function () { return null; })
        .then(function (data) {
          if (r.ok) return data || {};
          var err = new Error('cart-change');
          err.data = data || {};
          throw err;
        });
    });
  }

  function apply(cart) {
    if (cart && cart.sections) swapBody(cart.sections['cart-popup-lines']);
    if (cart && typeof cart.item_count === 'number') setCounts(cart.item_count);
  }

  function refresh() {
    return fetch('/?sections=cart-popup-lines')
      .then(function (r) { return r.json(); })
      .then(function (s) { swapBody(s['cart-popup-lines']); })
      .then(function () {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (c) { setCounts(c.item_count); });
      })
      .catch(function () { /* stary render zostaje — i tak jest poprawny */ });
  }

  function open() {
    if (dlg.open) return;
    lastFocus = document.activeElement;
    lock();
    dlg.showModal();
    refresh(); /* render z layoutu może być nieświeży (AJAX add) — dociągamy */
  }

  dlg.addEventListener('close', function () {
    unlock();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  });

  /* klik w tło (dialog wypełnia viewport, panel jest w środku) */
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) dlg.close();
  });

  /* Po podmianie sekcji wciśnięty przycisk już nie istnieje. Klawiatura
     nie może zgubić miejsca przy trzymaniu "+", więc fokus wraca na
     BLIŹNIACZY przycisk świeżej linii (a gdy linii nie ma — na panel). */
  function refocus(line, step, wasFocused) {
    if (!wasFocused) return;
    var twin = line && line.querySelector('[data-qty-step="' + step + '"]');
    if (twin && twin.focus) { twin.focus(); return; }
    if (panel && panel.focus) panel.focus();
  }

  /* Ścianki liczone DOKŁADNIE tak, jak renderuje je Liquid — dzięki temu
     stan optymistyczny i stan po rerenderze nigdy się nie kłócą. */
  function syncWalls(line, qty) {
    var pad = padOf(line);
    if (!pad) return;
    var max = parseInt(pad.getAttribute('data-qty-max'), 10);
    var minus = line.querySelector('[data-qty-step="-1"]');
    var plus = line.querySelector('[data-qty-step="1"]');
    if (minus) {
      if (qty <= 1) minus.setAttribute('aria-disabled', 'true');
      else minus.removeAttribute('aria-disabled');
    }
    if (plus) {
      if (max && qty >= max) plus.setAttribute('aria-disabled', 'true');
      else plus.removeAttribute('aria-disabled');
    }
  }

  /* Cyfra reaguje NATYCHMIAST (optymistycznie), serwer prostuje ją przy
     rerenderze. Stukanie w "+" trzy razy pod rząd nie może gubić stuknięć,
     więc w locie kolejkujemy DOCELOWĄ ilość (nie każdy krok osobno) —
     jeden request na serię, zero rozjazdu z /cart/change.js. */
  function stepLine(btn, delta) {
    var line = btn.closest('[data-cart-pop-line]');
    if (!line) return;
    var valEl = line.querySelector('[data-qty-value]');
    var current = parseInt(valEl ? valEl.textContent : '', 10);
    if (!current || current < 1) current = 1;
    var next = current + delta;
    if (next < 1) return; /* dół zamyka ścianka — usuwanie ma własny przycisk */

    if (valEl) valEl.textContent = next;
    syncWalls(line, next);

    var job = {
      key: btn.getAttribute('data-line-key'),
      want: next,
      step: btn.getAttribute('data-qty-step'),
      focused: document.activeElement === btn
    };
    if (busy) { queued = job; return; }
    send(line, job);
  }

  function send(line, job) {
    var pad = padOf(line);
    busy = true;

    post({ id: job.key, quantity: job.want, sections: 'cart-popup-lines' })
      .then(function (c) {
        apply(c);
        var fresh = findLine(job.key);
        var freshPad = padOf(fresh);
        var freshVal = fresh && fresh.querySelector('[data-qty-value]');
        var got = freshVal ? parseInt(freshVal.textContent, 10) : job.want;
        if (got < job.want) {
          /* 200 OK, ale serwer przyciął ilość — to NADAL odmowa, nie sukces.
             Cyfra wróciła już do prawdy (rerender), więc kolejka nie ma po
             co dobijać się o to samo. */
          queued = null;
          deny(fresh, noteText(freshPad, 'data-note-max'));
          announce(padLabel(freshPad) + ' — ' + noteText(freshPad, 'data-note-max'));
        } else {
          announce(withTotal(noteText(freshPad, 'data-qty-live').replace('%N%', got)));
        }
        refocus(fresh, job.step, job.focused);
      })
      .catch(function (err) {
        queued = null;
        var served = err && err.data;
        var msg = noteText(pad, served ? 'data-note-max' : 'data-note-error');
        var truth = parseInt(line.getAttribute('data-line-qty'), 10);
        var valEl = line.querySelector('[data-qty-value]');
        /* nic nie poszło — cyfra musi wrócić do ostatniej prawdy serwera */
        if (valEl && truth) { valEl.textContent = truth; syncWalls(line, truth); }
        deny(line, msg);
        announce(padLabel(pad) + ' — ' + ((served && (served.description || served.message)) || msg));
      })
      .finally(function () {
        busy = false;
        drain();
      });
  }

  /* dobicie serii stuknięć: wysyłamy JEDNĄ docelową ilość */
  function drain() {
    var job = queued;
    queued = null;
    if (!job) return;
    var line = findLine(job.key);
    if (!line) return;
    var valEl = line.querySelector('[data-qty-value]');
    var truth = parseInt(valEl ? valEl.textContent : '', 10);
    if (truth === job.want) return; /* serwer już tam jest */
    if (valEl) valEl.textContent = job.want;
    syncWalls(line, job.want);
    send(line, job);
  }

  function removeLine(btn) {
    if (busy) return;
    busy = true;
    var line = btn.closest('[data-cart-pop-line]');
    var key = btn.getAttribute('data-line-key');
    var msg = btn.getAttribute('data-removed-live');
    btn.disabled = true;
    if (line) line.classList.add('cart-pop__line--going');

    /* podmiana czeka na PÓŹNIEJSZE z dwojga: odpowiedź serwera albo koniec
       mikro-potwierdzenia. Pod reduced-motion nie czekamy w ogóle. */
    var hold = REDUCE.matches ? 0 : OUT_MS;
    Promise.all([
      post({ id: key, quantity: 0, sections: 'cart-popup-lines' }),
      new Promise(function (res) { window.setTimeout(res, hold); })
    ])
      .then(function (out) {
        apply(out[0]);
        announce(withTotal(msg));
        /* usunięty przycisk trzymał fokus — oddajemy go panelowi dialogu */
        if (panel && panel.focus && !dlg.contains(document.activeElement)) panel.focus();
      })
      .catch(function () {
        if (line) line.classList.remove('cart-pop__line--going');
        btn.disabled = false;
      })
      .finally(function () { busy = false; drain(); });
  }

  /* delegacja: openery są w headerze/toaście, sterowanie linią w podmienianym HTML */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) {
      /* cmd/ctrl/shift/alt + klik = normalna nawigacja (nowa karta itd.) */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      open();
      return;
    }
    if (!dlg.open) return;
    var closer = e.target.closest('[data-cart-pop-close]');
    if (closer) { dlg.close(); return; }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var line = step.closest('[data-cart-pop-line]');
      if (step.getAttribute('aria-disabled') === 'true') {
        /* ścianka: przycisk ŻYJE, więc ma czym odpowiedzieć — puls + notka.
           W dół notka kieruje do REMOVE (kasowanie musi być świadome). */
        var pad = padOf(line);
        var msg = noteText(pad, step.getAttribute('data-qty-step') === '1' ? 'data-note-max' : 'data-note-min');
        deny(line, msg);
        announce(padLabel(pad) + ' — ' + msg);
        return;
      }
      stepLine(step, parseInt(step.getAttribute('data-qty-step'), 10));
      return;
    }

    var rm = e.target.closest('[data-cart-pop-remove]');
    if (rm) removeLine(rm);
  });
})();
